/*global _ */
import SelectMixin from './mixin'
const mixins = [SelectMixin]

export default {
  name: 're-select',
  mixins,
}
